module.exports = __webpack_public_path__ + "img/ka14.9d19bd17.jpg";